/* istanbul ignore file */

export const GTM_ID = 'GTM-T7SB68X';
